import { AloBase, getDefaultAloBase } from './AloBase'
import { AloCmdForfait,cleanAloCmdForfait } from './AloCmdForfait'


export interface AloCmdRow extends AloBase {              
    crwTarif:number    
    crwTva:number
    crwQty:number
    crwRetour:boolean    
    forfait:AloCmdForfait|null
}

export const getDefaultAloCmdRow = ():AloCmdRow => {
    return {  
        ...getDefaultAloBase(),        
        crwTarif:0,
        crwTva:2000,
        crwQty:1,
        crwRetour:false,
        forfait:null,
    }
}

export const cleanAloCmdRow = (row:AloCmdRow) => {
    if(!row) return    
    if(!row.id) delete row.id    
    if(!row.forfait) delete row.forfait    
    cleanAloCmdForfait(row.forfait!)
}